import React from "react";

const TextArea = ({
  textLabel,
  required = false,
  className,
  onChange,
  name,
  placeholder = "",
  value,
  rows = 4,
}) => {
  return (
    <label className="text-sm font-light flex items-center justify-between">
      <div className="flex">
        {textLabel} {required && <span className="text-red-500">*</span>}
      </div>

      <textarea
        className={`appearance-none text-sm border border-gray-300 focus:border-gray-400 rounded-lg py-2 px-3 text-gray-500 leading-tight focus:outline-none font-normal ${className}`}
        onChange={onChange}
        name={`${name}`}
        placeholder={`${placeholder}`}
        required={required}
        defaultValue={value}
        rows={`${rows}`}
      ></textarea>
    </label>
  );
};

export default TextArea;
